import { render, staticRenderFns } from "./PurchaseCostingItem.vue?vue&type=template&id=5378c178&scoped=true&"
import script from "./PurchaseCostingItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseCostingItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCostingItem.vue?vue&type=style&index=0&id=5378c178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378c178",
  null
  
)

export default component.exports